import React, { useState, useEffect } from 'react';
import { Calendar, Check, X } from 'lucide-react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api/v1';

export default function DireccionParametrizaciones() {
    const [parametrizaciones, setParametrizaciones] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadParametrizaciones();
    }, []);

    const loadParametrizaciones = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${API_URL}/direccion/parametrizaciones`);
            const data = await response.json();
            setParametrizaciones(data.parametrizaciones || []);
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleDateChange = async (id, field, value) => {
        try {
            const param = parametrizaciones.find(p => p.id_parametro === id);

            // Convert empty strings to null for proper handling
            const newValue = value || null;
            const existingInicio = param.fecha_inicio ? new Date(param.fecha_inicio).toISOString().split('T')[0] : null;
            const existingFin = param.fecha_fin ? new Date(param.fecha_fin).toISOString().split('T')[0] : null;

            const updateData = {
                fecha_inicio: field === 'fecha_inicio' ? newValue : existingInicio,
                fecha_fin: field === 'fecha_fin' ? newValue : existingFin,
                estado: param.estado
            };

            await fetch(`${API_URL}/direccion/parametrizaciones/${id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(updateData)
            });
            loadParametrizaciones();
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const toggleEstado = async (id, currentEstado) => {
        try {
            const param = parametrizaciones.find(p => p.id_parametro === id);
            const newEstado = currentEstado === 'activo' ? 'inactivo' : 'activo';

            await fetch(`${API_URL}/direccion/parametrizaciones/${id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    fecha_inicio: param.fecha_inicio ? new Date(param.fecha_inicio).toISOString().split('T')[0] : null,
                    fecha_fin: param.fecha_fin ? new Date(param.fecha_fin).toISOString().split('T')[0] : null,
                    estado: newEstado
                })
            });
            loadParametrizaciones();
        } catch (error) {
            console.error('Error:', error);
        }
    };

    // Verificar si la fecha está dentro del rango activo
    const isDateActive = (param) => {
        const now = new Date();
        now.setHours(0, 0, 0, 0);

        if (param.estado !== 'activo') return false;
        if (!param.fecha_inicio || !param.fecha_fin) return false;

        const inicio = new Date(param.fecha_inicio);
        const fin = new Date(param.fecha_fin);

        return now >= inicio && now <= fin;
    };

    if (loading) return <div className="p-6 text-center">Cargando...</div>;

    return (
        <div className="p-4 md:p-6 max-w-5xl mx-auto">
            <div className="mb-6">
                <h1 className="text-xl font-bold text-gray-800">Dirección Académica &gt; Periodos</h1>
            </div>

            <div className="bg-white rounded-lg shadow overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead className="bg-gray-50 border-b">
                            <tr>
                                <th className="px-3 py-3 text-center font-semibold border">No</th>
                                <th className="px-3 py-3 text-center font-semibold border">Parámetro</th>
                                <th className="px-3 py-3 text-center font-semibold border">Fecha Inicio</th>
                                <th className="px-3 py-3 text-center font-semibold border">Fecha Fin</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y">
                            {parametrizaciones.length === 0 ? (
                                <tr><td colSpan="4" className="px-4 py-8 text-center text-gray-500">No hay parametrizaciones</td></tr>
                            ) : (
                                parametrizaciones
                                    .filter(p => !p.nombre.toLowerCase().includes('inscripción a cursos de extensión'))
                                    .map((p, index) => (
                                    <tr key={p.id_parametro} className="hover:bg-gray-50">
                                        <td className="px-4 py-3 text-center font-medium border">{index + 1}</td>
                                        <td className="px-4 py-3 border">{p.nombre}</td>
                                        <td className="px-4 py-3 border">
                                            <div className="flex items-center justify-center gap-2">
                                                <div className="relative">
                                                    <input
                                                        type="date"
                                                        value={p.fecha_inicio ? new Date(p.fecha_inicio).toISOString().split('T')[0] : ''}
                                                        onChange={(e) => handleDateChange(p.id_parametro, 'fecha_inicio', e.target.value)}
                                                        className="w-32 px-2 py-1 border rounded text-sm"
                                                    />
                                                </div>
                                                <button
                                                    onClick={() => toggleEstado(p.id_parametro, p.estado)}
                                                    className={`p-1.5 rounded-full ${isDateActive(p) ? 'bg-green-500 text-white' : 'bg-gray-200 text-gray-500'}`}
                                                    title={p.estado === 'activo' ? 'Activo - Click para desactivar' : 'Inactivo - Click para activar'}
                                                >
                                                    <Check size={16} />
                                                </button>
                                            </div>
                                        </td>
                                        <td className="px-4 py-3 border">
                                            <div className="flex items-center justify-center gap-2">
                                                <div className="relative">
                                                    <input
                                                        type="date"
                                                        value={p.fecha_fin ? new Date(p.fecha_fin).toISOString().split('T')[0] : ''}
                                                        onChange={(e) => handleDateChange(p.id_parametro, 'fecha_fin', e.target.value)}
                                                        className="w-32 px-2 py-1 border rounded text-sm"
                                                    />
                                                </div>
                                                <button
                                                    onClick={() => toggleEstado(p.id_parametro, p.estado)}
                                                    className={`p-1.5 rounded-full ${isDateActive(p) ? 'bg-green-500 text-white' : 'bg-gray-200 text-gray-500'}`}
                                                    title={p.estado === 'activo' ? 'Activo - Click para desactivar' : 'Inactivo - Click para activar'}
                                                >
                                                    <Check size={16} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
